module.exports = __webpack_public_path__ + "static/media/3-7.f6460a9e.mp3";